import { Component } from "@angular/core";
import { ConfigService, Filters, OneOf } from "../../../common";
import { ContainersFiltersModel } from "./container-filters.model";

@Component({
  selector: "containers-filters",
  templateUrl: "./containers-filters.html",
  standalone: false,
})
export class ContainersFilters implements Filters {
  model: ContainersFiltersModel;
  wasteTypeOptions: string[];
  sortOptions: string[];

  constructor(private configService: ConfigService) {
    this.model = new ContainersFiltersModel();

    this.configService.get().subscribe((config) => {
      this.wasteTypeOptions = config.wasteTypeOptions;
      this.sortOptions = config.containerSortingOptions;
    });
  }

  public get state(): string {
    return this.model.getState();
  }

  public set state(value: string) {
    this.model = new ContainersFiltersModel(value);

    this.model.type = OneOf(this.model.type, this.wasteTypeOptions);
    this.model.sortBy = OneOf(this.model.sortBy, this.sortOptions);
  }

  reset() {
    this.model = new ContainersFiltersModel();
  }
}
